import { render, staticRenderFns } from "./pixNavbar.vue?vue&type=template&id=346489f4&scoped=true"
import script from "./pixNavbar.vue?vue&type=script&lang=js"
export * from "./pixNavbar.vue?vue&type=script&lang=js"
import style0 from "./pixNavbar.vue?vue&type=style&index=0&id=346489f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346489f4",
  null
  
)

export default component.exports